import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootStateType } from '../store/RootReducer';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;
